export default __webpack_public_path__ + "static/media/ic_caret_left.7b2ff202.svg";